export const canPostMessageToWindow = (contentWindow, targetOrigin) => {
    if (!contentWindow || !targetOrigin) return false;

    try {
        const origin = contentWindow.location?.origin;
        return Boolean(origin) && origin !== 'null';
    } catch {
        return true;
    }
};
